import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Rohan Mehta",
    role: "Startup founder · Bengaluru",
    image:
      "https://images.pexels.com/photos/7580940/pexels-photo-7580940.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    quote:
      "I used to fat-finger exits every time a client Slack popped up. With Tradecure my SL just runs, my target just runs. Honestly the calmest I've traded in 4 years.",
  },
  {
    name: "Priya Sharma",
    role: "Product Manager · Pune",
    image:
      "https://images.pexels.com/photos/7580822/pexels-photo-7580822.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    quote:
      "Finally a platform that speaks in rupees. I set ₹3,000 max loss, pick a strategy, done. No Greeks, no YouTube rabbit holes.",
  },
  {
    name: "Arjun Iyer",
    role: "Side-income trader · Mumbai",
    image:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80&auto=format&fit=crop",
    quote:
      "The auto-transform thing saved me last Thursday. Market reversed, my strategy flipped, I came out flat instead of -40%. I wasn't even watching.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <div className="font-mono text-xs font-bold text-[#084392] tracking-[0.2em]">
            / FROM EARLY USERS
          </div>
          <h2 className="font-heading mt-3 text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter">
            Less screen.
            <br />
            <span className="text-[#084392]">More discipline.</span>
          </h2>
        </motion.div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="rounded-2xl border border-[#e2e8f0] bg-white p-7 hover:border-[#084392]/40 transition flex flex-col"
            >
              <div className="flex gap-1 text-[#084392]">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Star key={j} size={14} fill="#084392" stroke="#084392" />
                ))}
              </div>
              <p className="mt-5 text-[#0f172a] text-lg leading-relaxed font-medium">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-auto pt-6 flex items-center gap-3">
                <img
                  src={t.image}
                  alt={t.name}
                  className="h-11 w-11 rounded-full object-cover border border-[#e2e8f0]"
                />
                <div>
                  <div className="font-semibold text-[#0f172a]">{t.name}</div>
                  <div className="text-xs text-[#475569]">{t.role}</div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
